import { render, staticRenderFns } from "./BlockCompanyModal.vue?vue&type=template&id=bdce3568&"
import script from "./BlockCompanyModal.vue?vue&type=script&lang=js&"
export * from "./BlockCompanyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports